<template>
  <div>
    <panel Title="تنظیمات کلی" Des="در این منو میتوانید تنظیمات مربوط به درگاه های پرداخت و دیگر تنظیمات کلی در سامانه خود را انجام دهید." :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link text-dark active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true"> تنظیمات درگاه پرداخت</a>
            <a class="nav-item nav-link text-dark" id="nav-Account-tab" data-toggle="tab" href="#nav-Account" role="tab" aria-controls="nav-Account" aria-selected="false">تنظیمات حساب ها</a>

            <!-- <a class="nav-item nav-link text-dark" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">...</a> -->
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیمات درگاه پرداخت</h6>
              </template>
              <template slot="content">
                <div class="col-12 table-responsive">
                  <table class="table table-bordered table-hover rounded">
                    <thead>
                      <tr>
                        <th class="text-center" style="width: 20px">ردیف</th>
                        <th class="text-center">کد درگاه</th>
                        <th class="text-center" style="width: 20px">پیش فرض</th>
                        <th class="text-center" style="width: 20px">امکان تغییر مبالغ</th>
                        <th class="text-center">آدرس برگشت</th>
                        <th class="text-center">نام درگاه</th>
                        <th class="text-center" style="width: 8%">بازه فعالیت درگاه</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in Menu" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <input :disabled="!EditMode" type="text" class="text-left" v-model="Menu[index].gatewayCode" />
                        </td>
                        <td>
                          <span class="text-center">
                            <div class="custom-control custom-switch">
                              <input type="checkbox" :disabled="!EditMode" class="custom-control-input InputText" :checked="Menu[index].isDefault" v-model="Menu[index].isDefault" :id="Menu[index].id + 'isDefault'" />
                              <label class="custom-control-label mt-2 Pointer" :for="Menu[index].id + 'isDefault'"></label>
                            </div>
                          </span>
                        </td>
                        <td>
                          <span class="text-center">
                            <div class="custom-control custom-switch">
                              <input type="checkbox" :disabled="!EditMode" class="custom-control-input InputText" :checked="Menu[index].isFixVarizGhest" v-model="Menu[index].isFixVarizGhest" :id="Menu[index].id + 'isFixVarizGhest'" />
                              <label class="custom-control-label mt-2 Pointer" :for="Menu[index].id + 'isFixVarizGhest'"></label>
                            </div>
                          </span>
                        </td>
                        <td>
                          <input :disabled="!EditMode" type="text" class="text-left" v-model="Menu[index].callBackUrl" />
                        </td>
                        <td>
                          <input :disabled="!EditMode" type="text" class="text-right" v-model="Menu[index].persianName" />
                        </td>
                        <td>
                          <input :disabled="!EditMode" type="text" class="text-center" v-model="Menu[index].activeDay" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row">
                  <div class="col-md-9"></div>
                  <div class="col-md-3 col-12">
                    <button v-if="EditMode" class="btn btn-success w-100" @click="updatemenu">ثبت اطلاعات</button>
                    <button v-else class="btn btn-warning w-100" @click="EditMode = !EditMode">اصلاح</button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>
          <div class="tab-pane fade" id="nav-Account" role="tabpanel" aria-labelledby="nav-Account-tab">
            <!-- Mahdodiat Enteghal -->
            <net-pa-card :IsMinus="true" :IdElement="'TransferSetting'" :IsCollapse="true">
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیم محدودیت <b class="text-danger">انتقال</b> وجه</h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="col-md-4 col-12">
                    <small>انتخاب حساب </small>
                    <select class="form-control Pointer mt-2" v-model="DataAxios.wwwtblnoe" @change="ChangeNoe(false)">
                      <option :value="-1">-- انتخاب حساب --</option>
                      <option v-for="item in this.ListModel2" :key="item.id" :value="item">
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3 col-12" v-if="DataAxios.wwwtblnoeId != -1 && DataAxios.wwwtblnoeId != null">
                    <small>حداکثر مبلغ قبلی</small> {{ $cookies.get('VahedPool') }}
                    <input class="form-control mt-2 text-center 3ragham text-danger" disabled style="font-size: 16px" @keyup="$PutCommatoInput()" type="text" v-model="DataAxios.wwwtblnoe.maxMabEnteghalDarMah" />
                  </div>
                  <div class="col-md-3 col-12" v-if="DataAxios.wwwtblnoeId != -1 && DataAxios.wwwtblnoeId != null">
                    <small>حداکثر مبلغ انتقال در روز</small> {{ $cookies.get('VahedPool') }}
                    <input class="form-control mt-2 text-center 3ragham text-danger" style="font-size: 16px" @keyup="$PutCommatoInput()" type="text" v-model="DataAxios.Amount" />
                  </div>
                  <div class="col-md-2 col-12 text-center">
                    <button class="btn btn-outline-success rounded mt-4 w-100" @click="SetTaahodatList(false)">اعمال تغییرات</button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Mahdodiat Bardasht -->
            <net-pa-card class="mt-4" :IsMinus="true" :IdElement="'DebtorSetting'" :IsCollapse="true">
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیم محدودیت <b class="text-warning">برداشــت </b>وجه</h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="col-md-4 col-12">
                    <small>انتخاب حساب </small>
                    <select class="form-control Pointer mt-2" v-model="DataAxiosBardasht.wwwtblnoe" @change="ChangeNoe(true)">
                      <option :value="-1">-- انتخاب حساب --</option>
                      <option v-for="item in this.ListModel2" :key="item.id" :value="item">
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3 col-12" v-if="DataAxiosBardasht.wwwtblnoeId != -1 && DataAxiosBardasht.wwwtblnoeId != null">
                    <small>حداکثر مبلغ قبلی</small> {{ $cookies.get('VahedPool') }}
                    <input class="form-control mt-2 text-center 3ragham text-danger" disabled style="font-size: 16px" @keyup="$PutCommatoInput()" type="text" v-model="DataAxiosBardasht.wwwtblnoe.maxMabBardashtDarRoz" />
                  </div>
                  <div class="col-md-3 col-12" v-if="DataAxiosBardasht.wwwtblnoeId != -1 && DataAxiosBardasht.wwwtblnoeId != null">
                    <small>حداکثر مبلغ انتقال در روز</small> {{ $cookies.get('VahedPool') }}
                    <input class="form-control mt-2 text-center 3ragham text-danger" style="font-size: 16px" @keyup="$PutCommatoInput()" type="text" v-model="DataAxiosBardasht.Amount" />
                  </div>
                  <div class="col-md-2 col-12 text-center">
                    <button class="btn btn-outline-success rounded mt-4 w-100" @click="SetTaahodatList(true)">اعمال تغییرات</button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Tanzimat Peyvast hesabha -->
            <net-pa-card class="mt-4" :IsMinus="true" :IdElement="'Atachment'" :IsCollapse="true">
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیم پیوست حسابها</h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="alert alert-danger w-100 text-danger font-weight-bold text-center">کاربر گرامی : این بخش بهتر است توسط تیم برنامه نویس شرکت پاسارگاد تنظیم و تکمیل گردد</div>
                </div>
                <div class="row">
                  <div class="col-md-4 col-12">
                    <small>انتخاب حساب </small>
                    <select class="form-control Pointer mt-2" style="font-size: 16px" v-model="DataAxiosTashilat.wwwtblnoe" @change="ChangeTashilatNoe()">
                      <option :value="-1">-- انتخاب حساب مورد نظر --</option>
                      <option v-for="item in this.ListTashilat" :key="item.id" :value="item">
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-md-8 col-12">
                    <small> نام SP (پیوستی محاسبات) مربوطه </small>
                    <input class="form-control mt-2 text-left text-danger" dir="ltr" style="font-size: 16px" type="text" v-model="DataAxiosTashilat.SP" />
                  </div>
                  <div class="col-md-4 col-12 text-right mt-2">
                    <small> تنظیمات نمایش نفر X بر حسب امتیاز مکتسبه</small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" id="isShowMessage" v-model="DataAxiosTashilat.ShowMessageZeroScore" />
                        <label class="custom-control-label p-1" for="isShowMessage">نمایش </label>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-8 col-12 mt-2 text-right">
                    <small>پیغام در صورت نفر صفـــر بودن بر حسب امتیاز مکتسبه</small>
                    <input class="form-control mt-1" v-model="DataAxiosTashilat.MessageZeroScore" />
                  </div>
                  <div class="col-md-4 col-12 text-right mt-2">
                    {{ DataAxiosTashilat.ShowScore }}
                    <small> تنظیمات نمایش امتیاز </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" id="IsShowScore" v-model="DataAxiosTashilat.ShowScore" />
                        <label class="custom-control-label p-1" for="IsShowScore">نمایش </label>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-2 col-12 text-center mt-1">
                    <button class="btn btn-outline-success rounded mt-4 w-100" style="font-size: 16px" @click="SetTashilatList">اعمال تغییرات</button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Tanzimat Brge Saham -->
            <net-pa-card v-if="Number($session.get('UserInfoNetPa').custCode == 868 || $session.get('UserInfoNetPa').custCode == 801 || $session.get('UserInfoNetPa').custCode == 574 || $session.get('UserInfoNetPa').custCode == 886) " class="mt-4" :IsMinus="true" :IdElement="'Saham'" :IsCollapse="true">
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیم برگه سهـــــــــــام</h6>
              </template>
              <template slot="content">
                <div id="BargeSaham" class="row">
                  <div class="col-md-6 col-12">
                    <div class="row">
                      <div class="col-md-6 col-12 mt-3">
                        <small>انتخاب حساب </small>
                        <select class="form-control Pointer required" v-model="DataAxiosSaham.wwwtblNoeId">
                          <!-- <option  :value="-1">-- انتخاب حساب مورد نظر --</option> -->
                          <option v-for="item in this.ListTashilat" :key="item.id" :value="item.id">
                            <span>{{ item.desNoe }} </span>
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6 col-12 mt-3">
                        <small> شماره ثبت</small>
                        <input class="form-control text-center required" dir="ltr" type="text" v-model="DataAxiosSaham.shomareSabt" />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> تاریخ ثبت</small>
                        <date-picker input-class="required form-control" :editable="true" :auto-submit="true" color="#fa0" v-model="DataAxiosSaham.tarixSabt"> </date-picker>
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> ارزش هر سهم {{ $cookies.get('VahedPool') }}</small>
                        <input class="form-control text-center font-weight-bold 3ragham required" dir="ltr" type="text" @keyup="$PutCommatoInput()" v-model="DataAxiosSaham.arzeshHarSahm" />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> مشخصات رئیس هیئت مدیره</small>
                        <input class="form-control text-center required" dir="ltr" type="text" v-model="DataAxiosSaham.pishNevis1" />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> مشخصات مدیر عامل</small>
                        <input class="form-control text-center required" dir="ltr" type="text" v-model="DataAxiosSaham.pishNevis2" />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> سریال</small>
                        <input class="form-control text-center required" dir="ltr" type="text" v-model="DataAxiosSaham.serialNumber" />
                      </div>
                      <div class="col-md-6 col-12 mt-1">
                        <small> شناسه ملی </small>
                        <input class="form-control text-center required" dir="ltr" type="text" v-model="DataAxiosSaham.shenaseMeli" />
                      </div>
                      <div class="col-md-12 col-12 mt-2 text-right">
                        <small>پیغام در صورت نفر صفـــر بودن بر حسب امتیاز مکتسبه</small>
                        <input class="form-control mt-1" v-model="DataAxiosSaham.MessageZeroScore" />
                      </div>
                      <div class="col-md-4 col-12 text-right mt-2">
                        <small> تنظیمات نمایش نفر X بر حسب امتیاز مکتسبه</small>
                        <span class="form-control p-1 mt-1">
                          <div class="custom-control custom-switch text-center">
                            <input type="checkbox" class="custom-control-input InputText" id="isShowMessageSaham" v-model="DataAxiosSaham.ShowMessageZeroScore" />
                            <label class="custom-control-label p-1" for="isShowMessageSaham">نمایش </label>
                          </div>
                        </span>
                      </div>
                      <div class="col-md-4 col-12 text-right mt-2">
                        {{ DataAxiosSaham.ShowScore }}
                        <small> تنظیمات نمایش امتیاز </small>
                        <span class="form-control p-1 mt-1">
                          <div class="custom-control custom-switch text-center">
                            <input type="checkbox" class="custom-control-input InputText" id="isShowScore" v-model="DataAxiosSaham.ShowScore" />
                            <label class="custom-control-label p-1" for="isShowScore">نمایش </label>
                          </div>
                        </span>
                      </div>
                      <div class="col-md-12 col-12 mt-4">
                        <button type="button" class="btn btn-success" @click="SetSaham"><i class="fas fa-plus ml-2"></i>ثبت اطلاعات برگه سهام</button>
                      </div>
                    </div>
                  </div>
                  <!--start Tag Uploader -->
                  <div class="col-md-6 col-12">
                    <div class="row">
                      <div class="col-md-4 mt-3 col-12">
                        <uploader
                          :Idu="'Logo'"
                          v-if="$store.state.renderComponent"
                          :base64="GetBase(181070512)"
                          @Done="GetFile"
                          :attachId="GetId(181070512)"
                          :address="GetAddress(181070512)"
                          :grp="181070512"
                          :title="'تصویر لوگو برگه سهام'"
                          :MasterId="DataAxiosSaham.id"
                          :TableName="'wwwtblTanzimat'"
                        ></uploader>
                      </div>
                      <div class="col-md-4 mt-3 col-12">
                        <uploader :Idu="'Emza1'" v-if="$store.state.renderComponent" :base64="GetBase(181070510)" @Done="GetFile" :attachId="GetId(181070510)" :address="GetAddress(181070510)" :grp="181070510" :title="'امضا اول'" :MasterId="DataAxiosSaham.id" :TableName="'wwwtblTanzimat'"></uploader>
                      </div>
                      <div class="col-md-4 mt-3 col-12">
                        <uploader :Idu="'Emza2'" v-if="$store.state.renderComponent" :base64="GetBase(181070511)" @Done="GetFile" :attachId="GetId(181070511)" :address="GetAddress(181070511)" :grp="181070511" :title="'امضا دوم'" :MasterId="DataAxiosSaham.id" :TableName="'wwwtblTanzimat'"></uploader>
                      </div>
                    </div>
                  </div>
                  <!--End Tag Uploader -->
                </div>
              </template>
            </net-pa-card>
            <!-- Nemayesh Buttons Variz-Bardasht-Gardesh -->
            <net-pa-card class="mt-4" v-if="Number($session.get('UserInfoNetPa').custCode == 868 || $session.get('UserInfoNetPa').custCode == 8002 || $session.get('UserInfoNetPa').custCode == 886)" :IsMinus="true" :IdElement="'SettingsButton'" :IsCollapse="true">
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیم واریز | برداشت | گردش حسابها</h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="col-md-4 col-12">
                    <small>انتخاب حساب </small>
                    <select class="form-control Pointer mt-2" style="font-size: 16px" v-model="DataAxiosButtons.wwwtblnoe" @change="ChangeWwwtblNoeButtons">
                      <option :value="null">-- انتخاب حساب مورد نظر --</option>
                      <option v-for="item in this.ListTashilat" :key="item.id" :value="item">
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2 col-12" v-if="DataAxiosButtons.wwwtblnoe != null">
                    <small> تنظیمات دکمه واریز وجه</small>
                    <span class="form-control p-1 mt-2">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" id="isPayment" v-model="DataAxiosButtons.isPayment" />
                        <label class="custom-control-label p-1" for="isPayment">نمایش دکمه واریز </label>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-2 col-12" v-if="DataAxiosButtons.wwwtblnoe != null">
                    <small> تنظیمات دکمه برداشت وجه</small>
                    <span class="form-control p-1 mt-2">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" id="isDeptor" v-model="DataAxiosButtons.isDebtor" />
                        <label class="custom-control-label p-1" for="isDeptor">نمایش دکمه برداشت </label>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-2 col-12" v-if="DataAxiosButtons.wwwtblnoe != null">
                    <small> تنظیمات دکمه گردش</small>
                    <span class="form-control p-1 mt-2">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" id="isTernover" v-model="DataAxiosButtons.isTurnover" />
                        <label class="custom-control-label p-1" for="isTernover">نمایش دکمه گردش </label>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-2 col-12 text-center mt-2" v-if="DataAxiosButtons.wwwtblnoe != null">
                    <button class="btn btn-outline-success rounded mt-4 w-100" style="font-size: 16px" @click="SetSettingButtons">اعمال تغییرات</button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>
          <!-- <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">...</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import uploader from './Componenets/NetpaUploader.vue'
export default {
  components: {
    NetPaCard,
    Panel,
    uploader,
  },
  data() {
    return {
      file: [],
      Menu: [],
      EditMode: false,
      DataAxios: {},
      DataAxiosBardasht: {},
      ListModel2: null,
      ListTashilat: null,
      DataAxiosTashilat: {},
      DataAxiosSaham: {},
      DataAxiosButtons: { wwwtblnoe: null, wwwtblnoeId: null, isPayment: true, isDebtor: true, isTurnover: true },
    }
  },
  methods: {
    readMenus() {
      var DataAxiosRead = {
        ArryfildValue: {},
        Method: 'GET',
        Action: 'GetGateway',
      }
      this.$PostData(DataAxiosRead).then((data) => {
        this.Menu = data.data
      })
    },
    updatemenu() {
      this.$store.state.loading = true
      var DataAxiosUpdate = {
        ArryfildValue: {},
        Method: 'Put',
        Action: 'UpdateGateway',
      }
      DataAxiosUpdate.ArryfildValue = this.Menu
      this.$PutData_Body(DataAxiosUpdate).then((data) => {
        this.$store.state.loading = false
        if (data.status == 'Ok') {
          this.$mySweetDefault('عملیات موفق!', 'تغییرات با موفقیت ذخیره شد. برای اعمال یکبار از برنامه خارج شوید و دوباره وارد شوید', 'success', 3000)
        } else {
          this.$mySweetDefault('خطا!', 'در ثبت اطلاعات مشکلی رخ داده است. لطفا دوباره تلاش کنید', 'danger', 2000)
        }
        this.EditMode = !this.EditMode
        this.readMenus()
      })
    },
    GetTaahodatList() {
      var DataAxios_Noe = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TanzimatNoe',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      DataAxios_Noe.ArryfildValue = formData
      this.$PostFormData(DataAxios_Noe).then((data) => {
        this.ListModel2 = data.data
      })
    },
    SetTaahodatList(IsBardasht) {
      var DataAxios_Noe = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TanzimatNoe/SetSettings',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      if (IsBardasht) {
        formData.append('wwwtblNoeId', this.DataAxiosBardasht.wwwtblnoeId)
        formData.append('Amount', this.DataAxiosBardasht.Amount.replace(/,/g, '').replace(/\./g, ''))
      } else {
        formData.append('wwwtblNoeId', this.DataAxios.wwwtblnoeId)
        formData.append('Amount', this.DataAxios.Amount.replace(/,/g, '').replace(/\./g, ''))
      }
      formData.append('IsBardasht', IsBardasht)
      DataAxios_Noe.ArryfildValue = formData
      this.$PostFormData(DataAxios_Noe).then((data) => {
        if (data.status == 'Ok') {
          this.GetTaahodatList()
          this.DataAxios = {}
          this.DataAxiosBardasht = {}
          this.$mySweetDefaultTost(' ثبت موفق', 'تغییرات شما با موفقیت ثبت گردید', 'success', 2000)
        }
      })
    },
    ChangeNoe(IsBardasht) {
      if (IsBardasht) {
        this.DataAxiosBardasht.wwwtblnoeId = this.DataAxiosBardasht.wwwtblnoe.id
        this.DataAxiosBardasht.wwwtblnoe.maxMabEnteghalDarMah = this.$Comma3ragham(this.DataAxiosBardasht.wwwtblnoe.maxMabEnteghalDarMah)
      } else {
        this.DataAxios.wwwtblnoeId = this.DataAxios.wwwtblnoe.id
        this.DataAxios.wwwtblnoe.maxMabEnteghalDarMah = this.$Comma3ragham(this.DataAxios.wwwtblnoe.maxMabEnteghalDarMah)
      }
    },
    GetTashilatList() {
      var DataAxios_Noe = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TanzimatNoe/GettblNoe',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('NoeId', 2)
      DataAxios_Noe.ArryfildValue = formData
      this.$PostFormData(DataAxios_Noe).then((data) => {
        this.ListTashilat = data.data
      })
    },
    SetTashilatList() {
      var DataAxios_Noe = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TanzimatNoe/SetSettingsTashilat',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtblNoeId', this.DataAxiosTashilat.wwwtblnoeId)
      formData.append('SP', this.DataAxiosTashilat.SP)
      formData.append('MessageZeroScore', this.DataAxiosTashilat.MessageZeroScore)
      formData.append('ShowMessageZeroScore', this.DataAxiosTashilat.ShowMessageZeroScore)
      formData.append('ShowScore', this.DataAxiosTashilat.ShowScore)
      DataAxios_Noe.ArryfildValue = formData
      this.$PostFormData(DataAxios_Noe).then((data) => {
        if (data.status == 'Ok') {
          this.GetTashilatList()
          this.DataAxiosTashilat = {}
          this.$mySweetDefaultTost(' ثبت موفق', 'تغییرات شما با موفقیت ثبت گردید', 'success', 2000)
        } else {
          this.$mySweetDefaultTost('خطایی رخ داده', data.msg, 'danger', 2000)
        }
      })
    },
    ChangeTashilatNoe() {
      if (this.DataAxiosTashilat.wwwtblnoe.id) {
        this.DataAxiosTashilat.wwwtblnoeId = this.DataAxiosTashilat.wwwtblnoe.id
        this.DataAxiosTashilat.SP = this.DataAxiosTashilat.wwwtblnoe.spName.trim()
        this.DataAxiosTashilat.MessageZeroScore = this.DataAxiosTashilat.wwwtblnoe.messageZeroScore.trim()
        this.DataAxiosTashilat.ShowMessageZeroScore = this.DataAxiosTashilat.wwwtblnoe.showMessageZeroScore
        this.DataAxiosTashilat.ShowScore = this.DataAxiosTashilat.wwwtblnoe.showScore
        //console.log('😎 ~ ChangeTashilatNoe ~ this.DataAxiosTashilat:', this.DataAxiosTashilat)
      } else {
        this.DataAxiosTashilat = {}
      }
    },
    GetFile() {
      var dataAxios = {
        Method: 'POST',
        Action: 'Uploader/GetFile',
        ArryfildValue: {
          MasterId: this.DataAxiosSaham.id,
          tableName: 'wwwtblTanzimat',
        },
      }
      this.$PostData(dataAxios).then((result) => {
        if (result.data[0]) {
          if (result.data[0].wwwtblcomboidgrp328 == 181070512) {
            this.DataAxiosSaham.wwwtblImageIdLogo = result.data[0].id
          } else if (result.data[0].wwwtblcomboidgrp328 == 181070510) {
            this.DataAxiosSaham.wwwtblImageIdEmza1 = result.data[0].id
          } else if (result.data[0].wwwtblcomboidgrp328 == 181070511) {
            this.DataAxiosSaham.wwwtblImageIdEmza2 = result.data[0].id
          }
        }
        this.file = result.data
        this.$store.state.renderComponent = false
        this.$nextTick(() => {
          this.$store.state.renderComponent = true
        })
      })
    },
    GetBase(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id)
      if (binary) {
        return binary
      } else {
        return null
      }
    },
    GetAddress(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id)
      if (binary) {
        if (binary.filename.indexOf('.PDF') > 0 || binary.filename.indexOf('.pdf') > 0) {
          return '/Image/PdfFile.png'
        }
        if (binary.filename.indexOf('.zip') > 0 || binary.filename.indexOf('.rar') > 0) {
          return '/Image/ZipFile.png'
        }
        return 'data:image/png;base64,' + binary.binary
      } else {
        return null
      }
    },
    GetId(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id)
      if (binary) {
        return binary.id
      } else {
        return null
      }
    },
    SetSaham() {
      if (this.$ValidForm('BargeSaham')) {
        var DataAxios_NoeSaham = {
          ArryfildValue: '',
          Method: 'Post',
          Action: 'TanzimatNoe/UpdateSaham',
          Token: this.$session.get('TokenNetPa'),
        }
        const formData = new FormData()
        formData.append('wwwtblNoeId', this.DataAxiosSaham.wwwtblNoeId)
        formData.append('ShomareSabt', this.DataAxiosSaham.shomareSabt)
        formData.append('TarixSabt', this.DataAxiosSaham.tarixSabt)
        formData.append('ArzeshHarSahm', this.DataAxiosSaham.arzeshHarSahm)
        formData.append('PishNevis1', this.DataAxiosSaham.pishNevis1)
        formData.append('PishNevis2', this.DataAxiosSaham.pishNevis2)
        formData.append('ShenaseMeli', this.DataAxiosSaham.shenaseMeli)

        formData.append('SerialNumber', this.DataAxiosSaham.serialNumber)
        formData.append('wwwtblImageIdLogo', this.DataAxiosSaham.wwwtblImageIdLogo)
        formData.append('wwwtblImageIdEmza1', this.DataAxiosSaham.wwwtblImageIdEmza1 ? this.DataAxiosSaham.wwwtblImageIdEmza1 : 0)
        formData.append('wwwtblImageIdEmza2', this.DataAxiosSaham.wwwtblImageIdEmza2 ? this.DataAxiosSaham.wwwtblImageIdEmza2 : 0)
        formData.append('MessageZeroScore', this.DataAxiosSaham.MessageZeroScore)
        formData.append('ShowMessageZeroScore', this.DataAxiosSaham.ShowMessageZeroScore)
        formData.append('ShowScore', this.DataAxiosSaham.ShowScore)
        DataAxios_NoeSaham.ArryfildValue = formData
        this.$PostFormData(DataAxios_NoeSaham).then((data) => {
          if (data.status == 'Ok') {
            this.$mySweetDefaultTost(' ثبت موفق', 'تغییرات شما با موفقیت ثبت گردید', 'success', 2000)
          } else {
            this.$mySweetDefaultTost('خطایی رخ داده', data.msg, 'danger', 2000)
          }
        })
      }
    },
    getSahamsettings() {
      var DataAxios_GetSaham = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TanzimatNoe/GetSahamSettings',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      DataAxios_GetSaham.ArryfildValue = formData
      this.$PostFormData(DataAxios_GetSaham).then((data) => {
        this.DataAxiosSaham = data.data
        this.DataAxiosSaham.arzeshHarSahm = this.$Comma3ragham(this.DataAxiosSaham.arzeshHarSahm)
        this.DataAxiosSaham.MessageZeroScore = data.noe.messageZeroScore
        this.DataAxiosSaham.ShowMessageZeroScore = data.noe.showMessageZeroScore
        this.DataAxiosSaham.ShowScore = data.noe.showScore
      })
    },
    ChangeWwwtblNoeButtons() {
      this.DataAxiosButtons.wwwtblnoeId = this.DataAxiosButtons.wwwtblnoe.id
      this.DataAxiosButtons.isPayment = this.DataAxiosButtons.wwwtblnoe.isPayment
      this.DataAxiosButtons.isDebtor = this.DataAxiosButtons.wwwtblnoe.isDebtor
      this.DataAxiosButtons.isTurnover = this.DataAxiosButtons.wwwtblnoe.isTurnover
    },
    SetSettingButtons() {
      var DataAxios_Buttons = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TanzimatNoe/UpdateSettings',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtblNoeId', this.DataAxiosButtons.wwwtblnoeId)
      formData.append('isPayment', this.DataAxiosButtons.isPayment)
      formData.append('isDebtor', this.DataAxiosButtons.isDebtor)
      formData.append('isTurnover', this.DataAxiosButtons.isTurnover)
      DataAxios_Buttons.ArryfildValue = formData
      this.$PostFormData(DataAxios_Buttons).then((data) => {
        if (data.status == 'Ok') {
          this.GetTashilatList()
          this.DataAxiosButtons = {}
          this.$mySweetDefaultTost(' ثبت موفق', 'تغییرات شما با موفقیت ثبت گردید', 'success', 2000)
        }
      })
    },
  },
  created() {
    this.readMenus()
    this.GetTaahodatList()
    this.GetTashilatList()
    this.GetFile()
    this.getSahamsettings()
  },
}
</script>
<style scoped></style>


